import React from 'react';
import './InboundCall.css';
import CallerIdentification from '../CallerIdentification/CallerIdentification';
import CallContext from '../CallContext/CallContext';
import { FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const InboundCall = ({ onClose }) => {
  const navigate = useNavigate();

  const handleViewProfile = () => {
    onClose();
    navigate('/load-management');
  };

  return (
    <div className="inbound-call-modal">
      <div className="modal-header">
        <h3><span className="incoming-call-dot" />Incoming Call</h3>
        <span className="call-id">Call ID: #CTI-2024-1147</span>
      </div>
      <div className="modal-body">
        <CallerIdentification />
        <CallContext />
      </div>
      <div className="modal-footer">
        <button className="view-profile-btn" onClick={handleViewProfile}>
          View Full Carrier Profile <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default InboundCall;